import ProductForm from "../features/admin/ProductForm";

export default function AdminProductFormPage() {
  return <ProductForm />;
}
